import { myListsDetailsOptionsStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsOptions";
import { css } from "styled-components";

myListsDetailsOptionsStyles.container = {
    gap: 10,
    css: css`
        margin-top: 0px;
    `,
};
